import React from "react";
import { Navbar, Modal, Nav } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { menuSlice } from "redux/slices/menuSlice";
import { MENU_SIDE } from "redux/slices/api/initialisePreferences";
import NewDesignButton from "lib/NewDesignButton/NewDesignButton";
import { MobileMenu } from "./MobileMenu";
import HeaderTitle from "./parts/HeaderTitle";
import { SearchButton } from "./parts/SearchButton";

export function MobileHeader() {
  const dispatch = useDispatch();
  const menuSide = useSelector((state) => state.preferences)[MENU_SIDE][0];
  const { showMenu } = useSelector((state) => state.menu);
  const setShowMenu = (bool) => dispatch(menuSlice.actions.setShowMenu(bool));

  return (
    <>
      <Nav className="d-md-none w-100 flex-row">
        {menuSide === "Left" ? <MenuLeft setShowMenu={setShowMenu} /> : <MenuRight setShowMenu={setShowMenu} />}
      </Nav>

      <Modal show={showMenu} onHide={() => setShowMenu(false)} className="mobile-menu">
        <MobileMenu />
      </Modal>
    </>
  );
}

function MenuLeft({ setShowMenu }) {
  return (
    <>
      <Navbar.Toggle className="border-0" onClick={() => setShowMenu(true)} />
      <HeaderTitle />
      <NewDesignButton marginRight="8px" />
      <SearchButton />
    </>
  );
}
function MenuRight({ setShowMenu }) {
  return (
    <>
      <SearchButton />
      <HeaderTitle />
      <NewDesignButton />
      <Navbar.Toggle className="border-0" onClick={() => setShowMenu(true)} />
    </>
  );
}
